// import { createSelector } from 'reselect';
import { getBodyData, getWidgetsData } from 'store/selectors';

const getBodyBlocks = (state) => getBodyData(state).blocks || {};
export const getBodyVoteFormBlock = (state) => getBodyBlocks(state).voteForm || {};
/* Selector for, probably, subscribe method or/and GTM */
export const getBodyRequestUrl = (state) => getBodyData(state).requestUrl || '';

export const getVoteFormWidgetData = (state) => getWidgetsData(state).VoteForm || {};
export const getVoteCurrentActiveOptionId = (state) =>
  getVoteFormWidgetData(state).activeOptionId || '';
